import { buildURL } from "imgix-url-builder";
const imgixLoader = (args) => {
  const url = new URL(args.src);
  const params = {
    fit: url.searchParams.get("fit") || "max",
    w: args.width,
    h: void 0
  };
  if (args.quality) {
    params.q = args.quality;
  }
  return buildURL(args.src, params);
};
export {
  imgixLoader
};
//# sourceMappingURL=imgixLoader.js.map
